import { commonClient } from '@bip/api-client';
import type { GeoData } from '@bip/api-client';

export type { GeoData };

const SESSION_KEY = 'bip_geo';

// Returns geolocation for the current user via common-service (key stays server-side).
// Result is cached in sessionStorage — one API call per browser session.
export async function getGeolocation(): Promise<GeoData | null> {
  try {
    const cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) return JSON.parse(cached) as GeoData;
  } catch {
    // sessionStorage unavailable — proceed without cache
  }

  try {
    const res = await commonClient.getGeo();
    const result = res?.data ?? null;

    if (result) {
      try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(result));
      } catch {
        // ignore storage errors
      }
    }

    return result;
  } catch {
    return null;
  }
}
